<template>
  <div id="custom-menu">
    <el-menu
      :collapse="menuCollapse"
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      :unique-opened="true"
    >
      <template v-for="item in menus">
        <template v-if="item.subs">
          <el-submenu :index="item.path" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.menu_name }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.path"
                :key="subItem.index"
              >
                <template slot="title">{{ subItem.menu_name }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.path"
                  >{{ threeItem.name }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item v-else :index="subItem.path" :key="subItem.index">{{
                subItem.menu_name
              }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.path" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.menu_name }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "custom-menu",
  computed: {
    ...mapState(["menuCollapse"]),
    defaultActive() {
      let routeList = this.$route.path.replace("/", "").split("/");
      // console.log("当前-memu-的-----router-----", `/${routeList[0]}`);
      return `/${routeList[0]}`;
      // return this.$route.path.replace("/", "");
    },
    menus() {
      const path = this.$route.path;
      if (path == "/chooseScenic") {
        return [];
      } else {
        let menus = JSON.parse(localStorage.getItem("menus"));

        // menus.push({
        //   menu_name: "行为统计",
        //   menu_order: "12",
        //   path: "behavioralStatistics",
        // });

        return menus;
      }
    },
  },
  watch: {
    $route(to, from) {
      // 这个可以监听到用户手动输入页面路径，但是监听不到输入当前路径（也就会刷新当前页面）
      // console.log("$route",this.$route);
    },
  },
  data() {
    return {};
  },

  methods: {
    handleOpen(key, keyPath) {
      console.log("open", key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log("close", key, keyPath);
    },
    handleSelect(key) {
      this.$router.replace(key);
    },
  },
};
</script>

<style lang="scss" scoped>
#custom-menu {
  max-width: 200px;
  height: 100%;
  overflow-y: scroll;

  /*滚动条样式*/
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
</style>

<style >
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100%;
}

.el-menu--collapse {
  height: 100%;
}

.el-menu-item.is-active {
  background-color: #fe8c00 !important;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/menu.vue